import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  isConnectedDomain,
  isMediawireDomain,
  isNonRelAttrDomain,
} from 'config/public';
import { isSingleDomainPages } from 'utils/common';
import { isAffiliate, getEncodedAffiliateLink } from 'utils/Affiliate';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  shouldAppendFrmApp,
  appendFrmAppToUrl,
} from 'helpers/frmapp/frmAppLink';
import { TOI_LIVE_DOMAIN } from 'constants/index';
import {
  getReviewURL,
  isReviewsLink,
} from '../../../routes/articleshow_v2/utils/mspUtils';

const isSpotlightLink = linkUrl =>
  linkUrl &&
  linkUrl.includes('/spotlight/') &&
  linkUrl.includes('/articleshow/');

const Link = props => {
  const {
    to,
    url,
    href,
    target,
    children,
    skipAffiliateHandling,
    isNoLink,
    isMobile,
    isReviewsPage,
    commonState = {},
    ...restProps
  } = props;

  const getLiveURL = linkUrl => {
    const {
      siteConfig: { affiliates: { reviewsConfig = [] } = {} } = {},
    } = commonState;
    if (linkUrl && isReviewsLink(reviewsConfig, linkUrl, isReviewsPage)) {
      return getReviewURL(linkUrl);
    }
    let finalURL = linkUrl;
    const domain = TOI_LIVE_DOMAIN;
    if (props.isMobile && isSingleDomainPages(linkUrl)) {
      finalURL = linkUrl
        .split('m.timesofindia.com')
        .join('timesofindia.indiatimes.com');
    } else if (finalURL[0] === '/' && !props.route && !props.spa) {
      finalURL = domain + finalURL;
    } else if (
      props.isMobile &&
      linkUrl &&
      linkUrl.indexOf('timesofindia.indiatimes.com') > -1 &&
      linkUrl.indexOf('/liveblog/') === -1 &&
      linkUrl.indexOf('/blogs/') === -1 &&
      linkUrl.indexOf('/readersblog/') === -1 &&
      !props.doNotChangeDomain &&
      !props.doNotChangeURL
    ) {
      finalURL = linkUrl
        .split('timesofindia.indiatimes.com')
        .join('m.timesofindia.com');
    }
    return finalURL;
  };

  const handleClick = event => {
    if (props.data) {
      sendGaThroughProps({ data: props.data });
    }
    if (props.ga4Data && Array.isArray(props.ga4Data)) {
      analyticsWrapper('ga4', ...props.ga4Data);
    }
    if (props.ext) {
      return;
    }
    if (props.onClick && typeof props.onClick === 'function') {
      props.onClick(event);
      event.preventDefault();
    }

    if (props.isNoLink) {
      return;
    }
    const anchor = event.target.closest('a');
    if (!anchor) {
      return;
    }
    let newHref = anchor.href;
    if (anchor.href && !props.isMobile && shouldAppendFrmApp()) {
      event.preventDefault();
      window.location.href = appendFrmAppToUrl(newHref);
    } else if (props.isMobile && !props.disableClick) {
      event.preventDefault();
      if (
        !props.doNotChangeURL &&
        !props.doNotChangeDomain &&
        anchor.href &&
        anchor.href.indexOf('timesofindia.indiatimes.com') > 0 &&
        anchor.href.indexOf('/liveblog/') === -1 &&
        anchor.href.indexOf('/blogs/') === -1 &&
        anchor.href.indexOf('/readersblog/') === -1
      ) {
        newHref = newHref.replace(
          'timesofindia.indiatimes.com',
          'm.timesofindia.com',
        );
      }
      if (shouldAppendFrmApp()) {
        newHref = appendFrmAppToUrl(newHref);
      }
      if (anchor.getAttribute('target')) {
        window.open(newHref, '_blank');
      } else {
        window.location.href = newHref;
      }
    }
  };

  let linkUrl = to || url || (href || '');
  const isAffiliateLink = !skipAffiliateHandling && isAffiliate(linkUrl);
  let nofollow = props.rel || 'noopener nofollow noreferrer';
  const isThisConnectedDomain = isConnectedDomain(linkUrl);
  const isThisNonRelAttrDomain = isNonRelAttrDomain(linkUrl);

  if (
    (typeof linkUrl === 'string' &&
      (linkUrl.indexOf('timesofindia.indiatimes.com') >= 0 ||
        linkUrl.indexOf('m.timesofindia.com') >= 0 ||
        linkUrl.startsWith('/'))) ||
    isThisConnectedDomain ||
    isThisNonRelAttrDomain ||
    isReviewsPage
  ) {
    if (isMediawireDomain(linkUrl)) {
      nofollow = 'noopener nofollow';
    } else if (props.target === '_blank' && !isThisNonRelAttrDomain) {
      nofollow = 'noopener';
    } else {
      nofollow = undefined;
    }
  }

  if (isAffiliateLink) {
    const isWap = props.isMobile;
    nofollow += ' nofollow sponsored';
    linkUrl = getEncodedAffiliateLink('', linkUrl, isWap).replace(
      '<title>',
      '',
    );
  }
  if (props.rel && props.rel === 'sponsored noopener') {
    nofollow = 'sponsored noopener';
  }
  if (isSpotlightLink(linkUrl) && nofollow && !nofollow.includes('sponsored')) {
    nofollow += ' sponsored';
  }

  if (isNoLink) {
    return (
      <div {...restProps} onClick={handleClick}>
        {children}
      </div>
    );
  }

  if (target) {
    return (
      <a
        href={getLiveURL(linkUrl)}
        {...restProps}
        onClick={props.onClick || handleClick}
        rel={nofollow}
        // eslint-disable-next-line react/no-unknown-property
        frmappuse="1"
        data={undefined}
        ref={props.innerRef}
        target={target}
      >
        {children}
      </a>
    );
  }
  return (
    <a
      href={getLiveURL(linkUrl)}
      {...restProps}
      onClick={props.onClick || handleClick}
      rel={nofollow}
      // eslint-disable-next-line react/no-unknown-property
      frmappuse="1"
      data={undefined}
      ref={props.innerRef}
    >
      {children}
    </a>
  );
};

Link.propTypes = {
  to: PropTypes.string,
  url: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
  href: PropTypes.string,
  isNoLink: PropTypes.bool,
  route: PropTypes.string,
  doNotChangeURL: PropTypes.bool,
  doNotChangeDomain: PropTypes.bool,
  skipAffiliateHandling: PropTypes.bool,
  rel: PropTypes.string,
  isMobile: PropTypes.bool,
  isReviewsPage: PropTypes.bool,
  target: PropTypes.bool,
  commonState: PropTypes.shape({}),
};

Link.defaultProps = {
  onClick: null,
  to: undefined,
  url: undefined,
  children: null,
  href: undefined,
  isNoLink: false,
  route: undefined,
  doNotChangeURL: true,
  doNotChangeDomain: true,
  skipAffiliateHandling: false,
  rel: undefined,
  isMobile: false,
  isReviewsPage: false,
  target: '',
  commonState: {},
};

const mapStateToProps = state => ({
  isMobile: state.isMobile,
  isReviewsPage: state.isTOIReviews,
  commonState: state.common,
});

const ConnectedLinkComponent = connect(mapStateToProps)(Link);
export default React.forwardRef((props, ref) => (
  <ConnectedLinkComponent innerRef={ref} {...props} />
));
